import { render, staticRenderFns } from "./modificarOficioGenerado.vue?vue&type=template&id=dae96686"
import script from "./modificarOficioGenerado.vue?vue&type=script&lang=js"
export * from "./modificarOficioGenerado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports